interface SourceRequirementParams {
	rights: string
	isInt: boolean
	isMain: boolean
}

export const isSourceRequired = ({
	rights,
	isInt,
	isMain
}: SourceRequirementParams): boolean => {
	const normalizedRights = rights.trim()

	return (
		(isInt &&
			(normalizedRights === 'pool' || normalizedRights === 'non-exclusive')) ||
		(isMain && normalizedRights === 'pool')
	)
}
